module.exports = __webpack_public_path__ + "img/James_Ruskin.47c24c0c.jpg";